import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import s from "./slider.module.scss";
import NavArrowIcon from "@/shared/assets/icons/nav-arrow-icon.svg";
export var Slider = function (_a) {
    var containerRef = _a.containerRef, itemCount = _a.itemCount, counter = _a.counter, className = _a.className;
    var EDGE_EPSILON = 1;
    var _b = useState(0), index = _b[0], setIndex = _b[1];
    var _c = useState(true), canScrollRight = _c[0], setCanScrollRight = _c[1];
    var _d = useState(false), canScrollLeft = _d[0], setCanScrollLeft = _d[1];
    var getScrollMetrics = function (el) {
        var cards = Array.from(el.children);
        if (!cards.length)
            return null;
        var styles = window.getComputedStyle(el);
        var paddingLeft = parseFloat(styles.paddingLeft || "0");
        var maxScrollLeft = Math.max(0, el.scrollWidth - el.clientWidth);
        var snapPoints = cards
            .map(function (card) { return Math.max(0, Math.min(maxScrollLeft, card.offsetLeft - paddingLeft)); })
            .filter(function (value, idx, arr) { return idx === 0 || Math.abs(value - arr[idx - 1]) > EDGE_EPSILON; });
        if (!snapPoints.length)
            return null;
        return { maxScrollLeft: maxScrollLeft, snapPoints: snapPoints };
    };
    var updateScrollState = function () {
        var el = containerRef.current;
        if (!el)
            return;
        var metrics = getScrollMetrics(el);
        if (!metrics)
            return;
        var normalizedScrollLeft = Math.max(0, Math.min(metrics.maxScrollLeft, el.scrollLeft));
        var currentIndex = metrics.snapPoints.reduce(function (closestIdx, point, pointIdx) {
            var closestDistance = Math.abs(metrics.snapPoints[closestIdx] - normalizedScrollLeft);
            var currentDistance = Math.abs(point - normalizedScrollLeft);
            return currentDistance < closestDistance ? pointIdx : closestIdx;
        }, 0);
        var lastSnapIndex = metrics.snapPoints.length - 1;
        setCanScrollLeft(normalizedScrollLeft > EDGE_EPSILON);
        setCanScrollRight(normalizedScrollLeft < metrics.maxScrollLeft - EDGE_EPSILON);
        setIndex(Math.min(itemCount - 1, Math.min(lastSnapIndex, currentIndex)));
    };
    useEffect(function () {
        updateScrollState();
        var el = containerRef.current;
        if (!el)
            return;
        var handler = function () { return updateScrollState(); };
        el.addEventListener("scroll", handler);
        window.addEventListener("resize", handler);
        return function () {
            el.removeEventListener("scroll", handler);
            window.removeEventListener("resize", handler);
        };
    }, [containerRef, itemCount]);
    var scroll = function (dir) {
        var container = containerRef.current;
        if (!container)
            return;
        var metrics = getScrollMetrics(container);
        if (!metrics)
            return;
        var currentScrollLeft = Math.max(0, Math.min(metrics.maxScrollLeft, container.scrollLeft));
        var currentIndex = metrics.snapPoints.reduce(function (closestIdx, point, pointIdx) {
            var closestDistance = Math.abs(metrics.snapPoints[closestIdx] - currentScrollLeft);
            var currentDistance = Math.abs(point - currentScrollLeft);
            return currentDistance < closestDistance ? pointIdx : closestIdx;
        }, 0);
        var direction = dir === "left" ? -1 : 1;
        var targetIndex = Math.max(0, Math.min(metrics.snapPoints.length - 1, currentIndex + direction));
        var nextScrollLeft = metrics.snapPoints[targetIndex];
        container.scrollTo({ left: nextScrollLeft, behavior: "smooth" });
    };
    return (_jsxs("div", { className: "".concat(s.nav, " ").concat(className), children: [_jsxs("div", { className: s.btns, children: [_jsx("button", { className: s.button, onClick: function () { return scroll("left"); }, disabled: !canScrollLeft, children: _jsx(NavArrowIcon, { style: { transform: "rotate(180deg)" } }) }), _jsx("button", { className: s.button, onClick: function () { return scroll("right"); }, disabled: !canScrollRight, children: _jsx(NavArrowIcon, {}) })] }), counter && (_jsx("span", { className: s.counter, children: "".concat(index + 1, " / ").concat(itemCount) }))] }));
};
